import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { Field, reduxForm } from 'redux-form';

// Component
import { FormElems } from '../../components/';

export const SearchBar = props => {
    const { handleSubmit, isReset, reset, untouch } = props;
    const history = useHistory();
    const inputEl = useRef(null);

    useEffect(() => {
        if (isReset) {
            reset();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isReset, reset]);

    const handleFormSubmit = values => {
        history.push(`/manage-bin/search/${values.search}`);
        if (isReset) {
            reset();
            inputEl.current.blur();
            untouch('search-bar', 'search');
        }
    };

    return (
        <form className="search-bar" onSubmit={handleSubmit(handleFormSubmit)}>
            <Field
                name="search"
                type="text"
                placeholder="Search Bin"
                inputRef={inputEl}
                component={FormElems.Input}
            />
            <button type="submit" className="search-icon">
                <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                >
                    <title>Search</title>
                    <path
                        fill="#8d8d8d"
                        d="M22.222 19.556h-1.422l-0.533-0.533c1.778-1.956 2.844-4.622 2.844-7.467 0-6.4-5.156-11.556-11.556-11.556s-11.556 5.156-11.556 11.556c0 6.4 5.156 11.556 11.556 11.556 2.844 0 5.511-1.067 7.467-2.844l0.533 0.533v1.422l8.889 8.889 2.667-2.667-8.889-8.889zM11.556 19.556c-4.444 0-8-3.556-8-8s3.556-8 8-8c4.444 0 8 3.556 8 8s-3.556 8-8 8v0z"
                    />
                </svg>
            </button>
        </form>
    );
};

SearchBar.propTypes = {
    handleSubmit: PropTypes.func,
    isReset: PropTypes.bool,
    reset: PropTypes.func,
    untouch: PropTypes.func,
};

const validate = values => {
    const errors = {};
    const isValid = /^[0-9\d\s]+$/i.test(values.search);
    if (!values.search) {
        errors.search = 'Please enter a bin to search';
    } else if (!isValid) {
        errors.search = 'Only numbers are allowed';
    } else if (!/^\S+$/.test(values.search)) {
        errors.search = 'Spaces not allowed in search';
    } else if (values.search.length !== 6) {
        errors.search = 'Must be 6 characters';
    }
    return errors;
};

export default reduxForm({
    form: 'search-bar',
    validate,
    destroyOnUnmount: true,
})(SearchBar);
